import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { domain } from '../../../utils/variables';

const DomainChecker = () => {
  const parentAlpha2 = useSelector(
    state => state?.locations?.yourLocation?.parentTerritory?.alpha2,
  );
  const tempAllowedDomains =
    parentAlpha2 === 'AN' ? domain?.fatumAllowedDomains : domain?.allowedPWADomains;
  const allowedDomains = tempAllowedDomains?.split(',');
  const isUnofficialDomainAllowed =
    allowedDomains && allowedDomains?.some(x => window.location.href.indexOf(x) > -1);

  const officialDomain = parentAlpha2 === 'AN' ? domain?.fatumPWA : domain.pwa;

  useEffect(() => {
    if (
      window.location.href.indexOf(officialDomain) < 0 &&
      window.location.href.indexOf('localhost') < 0 &&
      (domain?.env === 'production' || domain?.env === 'staging')
    ) {
      if (allowedDomains && isUnofficialDomainAllowed) {
        // don't redirect
      } else if (window.location.pathname === '/') window.location.href = officialDomain;
      else
        window.location.href =
          officialDomain + window.location.pathname + window.location.search;
    }
  }, [parentAlpha2]);

  return <></>;
};

export default DomainChecker;
